import { render, staticRenderFns } from "./ParticipatingProductGroups.vue?vue&type=template&id=0543366c&scoped=true"
import script from "./ParticipatingProductGroups.vue?vue&type=script&lang=js"
export * from "./ParticipatingProductGroups.vue?vue&type=script&lang=js"
import style0 from "./ParticipatingProductGroups.vue?vue&type=style&index=0&id=0543366c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543366c",
  null
  
)

export default component.exports